<div class="body">

    <mat-toolbar class="ams-toolbar">
        <button mat-icon-button>
            <mat-icon>assessment</mat-icon>
        </button>
        <span>Vertrag auswählen</span>
        <span class="spacer"></span>
        <button mat-icon-button color="warn" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content">

        <mat-form-field class="width" appearance="fill">

            <mat-label>Vertrag suchen</mat-label>
            <input type="text" placeholder='Suchbegriff eingeben' matInput [formControl]="formControl"
                (keyup.enter)="search()" />
            <mat-icon matSuffix>search</mat-icon>

        </mat-form-field>

        <div class="results preview-entry-container" *ngIf="contracts.length > 0; else noContracts">

            <div class="preview-entry" *ngFor="let contract of contracts" (click)="contractClicked(contract)">
                <app-contract-preview [contract]="contract"></app-contract-preview>
            </div>

            <div class="load-more-wrapper" *ngIf="total > contracts.length">

                <button mat-raised-button (click)="loadMore()">
                    Mehr laden
                </button>

            </div>

        </div>

        <div class="footer">

            {{contracts.length}} von {{total}}
    
        </div>

    </div>

</div>

<ng-template #noContracts>

    <div class="no-contracts-hint">

        <div class="text">Kein Vertrag gefunden</div>

    </div>

</ng-template>
